<!--

    Copyright (c) 2017-present, Siklu Ltd.
    All rights reserved.

-->
<div class="stretch-to-parent">
    <div class="main-box">
        <div class="header">
            <router-outlet name="navbar"></router-outlet>
        </div>
        <div
                [config]="preloaderService.getLoadingConfig(preloaderService.getMainLoaderId())"
                [suiIsLoading]="preloaderService.getMainLoaderId()"
                class="content"
                style="position: relative"
        >
            <div class="stretch-to-parent">
                <router-outlet></router-outlet>
                <router-outlet name="popup"></router-outlet>
            </div>
        </div>
    </div>
</div>

<winde-access-denied-modal></winde-access-denied-modal>
<winde-auto-logout-modal></winde-auto-logout-modal>
